export default __webpack_public_path__ + "static/la_paresse-5bac57a439151ae7b683770a77275060.mp3";